'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

// DI skaiciuokle
EwSiteApp.controller('DICalcCtrl', ['$scope', function ($scope) {
		$scope.showInfo = false;
		$scope.statusPareiskejoInfo = false;
		$scope.statusBendraInfo = false;

		$scope.susijusiosI = [];
		$scope.pareiskejoI = {
			'nuosavas': '',
			'istatinis': ''
		};


		// DI
		$scope.showDICalcForms = false;
		$scope.showDIInfo = false;
		$scope.hasDIDificultiesPareiskejas = false;
		$scope.hasDIDificultiesImones = false;

		$scope.susijusiuImoniuDuomenys = [];
		$scope.pareiskejoVertinimas = {
			'lastyear': {
				'sumuIsipareigojimai': '',
				'nuosavasKapitalas': '',
				'pelnasPriesMokescius': '',
				'sumoketosPalukanos': '',
				'nusidevejimas': '',
			},
			'penultyear': {
				'sumuIsipareigojimai': '',
				'nuosavasKapitalas': '',
				'pelnasPriesMokescius': '',
				'sumoketosPalukanos': '',
				'nusidevejimas': '',
			}
		};

//	DI paskaiciavimu konstantos
		var SKOLOS_KAPITALO_SANTYKIS_VAL = 7.5;
		var EBITDA_SANTYKIS_VAL = 1;


		// Ar imone patiria sunkumus
		var hasDifficulties = function (kapitalas, istatinisKapitalas) {
			// jei kapitalas mažesnis už pusę įstatinio, įmonė laikoma patiriančia sunkumus
			if (kapitalas < istatinisKapitalas / 2) {
				return false;
			}
			return true;
		};

		var calculateAllBlocksTotal = function () {
			var susijusiuNuosavasTotal = 0;
			var susijusiuIstatinisTotal = 0;

			for (var i = 0, l = $scope.susijusiosI.length; i < l; i++) {
				susijusiuNuosavasTotal += $scope.susijusiosI[i].nuosavas;
				susijusiuIstatinisTotal += $scope.susijusiosI[i].istatinis;
			}

			var nuosavasTotal = susijusiuNuosavasTotal + $scope.pareiskejoI.nuosavas;
			var istatinisTotal = susijusiuIstatinisTotal + $scope.pareiskejoI.istatinis;

			return hasDifficulties(nuosavasTotal, istatinisTotal);
		};

		$scope.submitOnEnter = function (e) {
			if (e.which === 13 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
				e.preventDefault();

				if ($scope.checkAllFields()) {
					return false;
				}

				$scope.calculate();
			}
		};

		$scope.calculate = function () {
			$scope.showInfo = true;
			$scope.showDICalcForms = false;

			$scope.statusPareiskejoInfo = hasDifficulties($scope.pareiskejoI.nuosavas, $scope.pareiskejoI.istatinis);
			if ($scope.susijusiosI.length > 0) {
				$scope.statusBendraInfo = calculateAllBlocksTotal();
			}

			if ($scope.statusPareiskejoInfo && $scope.susijusiosI.length == 0 || $scope.statusPareiskejoInfo && $scope.statusBendraInfo) {
				$scope.showDICalcForms = true;

				$scope.pareiskejoVertinimas.lastyear.nuosavasKapitalas = $scope.pareiskejoI.nuosavas;

				if ($scope.susijusiosI.length) {
					$scope.generateDIForms();
				}
			}
		};

		$scope.add = function () {
			$scope.susijusiosI.push({
				'nuosavas': '',
				'istatinis': ''
			});

			$scope.resetForm();
		};

		$scope.remove = function (index) {
			$scope.susijusiosI.splice(index, 1);

			$scope.resetForm();
		};

		$scope.checkAllFields = function () {
			if (!angular.isNumber($scope.pareiskejoI.nuosavas) || !angular.isNumber($scope.pareiskejoI.istatinis)) {
				return true;
			}

			if ($scope.susijusiosI.length > 0) {
				for (var i = 0, l = $scope.susijusiosI.length; i < l; i++) {
					if (!angular.isNumber($scope.susijusiosI[i].nuosavas) || !angular.isNumber($scope.susijusiosI[i].istatinis)) {
						return true;
					}
				}
			}

			return false;
		};

		$scope.resetForm = function () {
			$scope.showInfo = false;
			$scope.statusPareiskejoInfo = false;
			$scope.statusBendraInfo = false;

			$scope.resetDIForm();
		};

		$scope.resetDIForm = function () {
			$scope.susijusiuImoniuDuomenys = [];
			$scope.hasDIDificultiesPareiskejas = false;
			$scope.hasDIDificultiesImones = false;
			$scope.showDIInfo = false;
			$scope.showDICalcForms = false;
		};

		var isNotAllNumbers = function (obj) {
			for (var i in obj) {
				if (!angular.isNumber(obj[i])) {
					return true;
				}
			}

			return false;
		};

		$scope.checkDIAllFields = function () {
			if (isNotAllNumbers($scope.pareiskejoVertinimas.lastyear)) {
				return true;
			}
			if (isNotAllNumbers($scope.pareiskejoVertinimas.penultyear)) {
				return true;
			}

			if ($scope.susijusiuImoniuDuomenys.length > 0) {
				for (var i = 0, l = $scope.susijusiuImoniuDuomenys.length; i < l; i++) {
					if (isNotAllNumbers($scope.susijusiuImoniuDuomenys[i].lastyear)) {
						return true;
					}
					if (isNotAllNumbers($scope.susijusiuImoniuDuomenys[i].penultyear)) {
						return true;
					}
				}
			}

			return false;
		};

		$scope.generateDIForms = function () {
			$scope.susijusiuImoniuDuomenys = [];

			for (var i = 0, l = $scope.susijusiosI.length; i < l; i++) {
				$scope.susijusiuImoniuDuomenys.push({
					'lastyear': {
						'sumuIsipareigojimai': '',
						'nuosavasKapitalas': $scope.susijusiosI[i].nuosavas,
						'pelnasPriesMokescius': '',
						'sumoketosPalukanos': '',
						'nusidevejimas': '',
					},
					'penultyear': {
						'sumuIsipareigojimai': '',
						'nuosavasKapitalas': '',
						'pelnasPriesMokescius': '',
						'sumoketosPalukanos': '',
						'nusidevejimas': '',
					}
				});
			}
		};

		$scope.calculateAdditionalAssessment = function () {
			$scope.showDIInfo = true;

			var sumuIsipareigojimaiPenultyear = $scope.pareiskejoVertinimas.penultyear.sumuIsipareigojimai;
			var sumuIsipareigojimaiLastyear = $scope.pareiskejoVertinimas.lastyear.sumuIsipareigojimai;
			var nuosavasKapitalasPenultyear = $scope.pareiskejoVertinimas.penultyear.nuosavasKapitalas;
			var nuosavasKapitalasLastyear = $scope.pareiskejoVertinimas.lastyear.nuosavasKapitalas;
			var pelnasPriesMokesciusPenultyear = $scope.pareiskejoVertinimas.penultyear.pelnasPriesMokescius;
			var pelnasPriesMokesciusLastyear = $scope.pareiskejoVertinimas.lastyear.pelnasPriesMokescius;
			var sumoketosPalukanosPenultyear = $scope.pareiskejoVertinimas.penultyear.sumoketosPalukanos;
			var sumoketosPalukanosLastyear = $scope.pareiskejoVertinimas.lastyear.sumoketosPalukanos;
			var nusidevejimasPenultyear = $scope.pareiskejoVertinimas.penultyear.nusidevejimas;
			var nusidevejimasLastyear = $scope.pareiskejoVertinimas.lastyear.nusidevejimas;

//		Apskaiciuojamas pareiskejo blokas

			var skolosKapitaloSantykisPenultyear = calculateSkolosKapitaloSantykis(sumuIsipareigojimaiPenultyear, nuosavasKapitalasPenultyear);
			var skolosKapitaloSantykisLastyear = calculateSkolosKapitaloSantykis(sumuIsipareigojimaiLastyear, nuosavasKapitalasLastyear);
			var EBITDASantykisPenultyear = calculateEBITDASantykis(pelnasPriesMokesciusPenultyear, sumoketosPalukanosPenultyear, nusidevejimasPenultyear);
			var EBITDASantykisLastyear = calculateEBITDASantykis(pelnasPriesMokesciusLastyear, sumoketosPalukanosLastyear, nusidevejimasLastyear);

			if (skolosKapitaloSantykisPenultyear > SKOLOS_KAPITALO_SANTYKIS_VAL && skolosKapitaloSantykisLastyear > SKOLOS_KAPITALO_SANTYKIS_VAL && EBITDASantykisPenultyear < EBITDA_SANTYKIS_VAL && EBITDASantykisLastyear < EBITDA_SANTYKIS_VAL) {
//			console.log('Pareiskejas patiria sunkumus');
				$scope.hasDIDificultiesPareiskejas = true;
			} else {
//			console.log('Pareiskejas nepatiria sunkumu');
				$scope.hasDIDificultiesPareiskejas = false;
			}


//		Apskaiciuojamas imoniu blokas

			if ($scope.susijusiuImoniuDuomenys.length > 0) {
				for (var i = 0, l = $scope.susijusiuImoniuDuomenys.length; i < l; i++) {
					var it = $scope.susijusiuImoniuDuomenys[i];
					sumuIsipareigojimaiPenultyear += it.penultyear.sumuIsipareigojimai;
					sumuIsipareigojimaiLastyear += it.lastyear.sumuIsipareigojimai;
					nuosavasKapitalasPenultyear += it.penultyear.nuosavasKapitalas;
					nuosavasKapitalasLastyear += it.lastyear.nuosavasKapitalas;
					pelnasPriesMokesciusPenultyear += it.penultyear.pelnasPriesMokescius;
					pelnasPriesMokesciusLastyear += it.lastyear.pelnasPriesMokescius;
					sumoketosPalukanosPenultyear += it.penultyear.sumoketosPalukanos;
					sumoketosPalukanosLastyear += it.lastyear.sumoketosPalukanos;
					nusidevejimasPenultyear += it.penultyear.nusidevejimas;
					nusidevejimasLastyear += it.lastyear.nusidevejimas;
				}

				var skolosKapitaloSantykisPenultyear = calculateSkolosKapitaloSantykis(sumuIsipareigojimaiPenultyear, nuosavasKapitalasPenultyear);
				var skolosKapitaloSantykisLastyear = calculateSkolosKapitaloSantykis(sumuIsipareigojimaiLastyear, nuosavasKapitalasLastyear);
				var EBITDASantykisPenultyear = calculateEBITDASantykis(pelnasPriesMokesciusPenultyear, sumoketosPalukanosPenultyear, nusidevejimasPenultyear);
				var EBITDASantykisLastyear = calculateEBITDASantykis(pelnasPriesMokesciusLastyear, sumoketosPalukanosLastyear, nusidevejimasLastyear);

				if (skolosKapitaloSantykisPenultyear > SKOLOS_KAPITALO_SANTYKIS_VAL && skolosKapitaloSantykisLastyear > SKOLOS_KAPITALO_SANTYKIS_VAL && EBITDASantykisPenultyear < EBITDA_SANTYKIS_VAL && EBITDASantykisLastyear < EBITDA_SANTYKIS_VAL) {
//				console.log('Pareiskejas patiria sunkumus');
					$scope.hasDIDificultiesImones = true;
				} else {
//				console.log('Pareiskejas nepatiria sunkumu');
					$scope.hasDIDificultiesImones = false;
				}
			}
		};

		$scope.submitOnEnterDI = function (e) {
			if (e.which === 13 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
				e.preventDefault();

				if ($scope.checkDIAllFields()) {
					return false;
				}

				$scope.calculateAdditionalAssessment();
			}
		};

		var calculateSkolosKapitaloSantykis = function (sumosIsipareigojimai, nuosavasKapitalas) {
			var skolosKapitaloSantykis = sumosIsipareigojimai / nuosavasKapitalas;
//		console.log(skolosKapitaloSantykis);
			return skolosKapitaloSantykis;
		};

		var calculateEBITDASantykis = function (pelnasPriesMokescius, sumoketosPalukanos, nusidevejimas) {
			var EBITDASantykis = (pelnasPriesMokescius + sumoketosPalukanos + nusidevejimas) / sumoketosPalukanos;
//		console.log(EBITDASantykis);
			return EBITDASantykis;
		};
	}]);

//https://invega.lt/lt/covid-19/kas-yra-sunkumu-patirianti-imone/sunkumu-vertinimo-skaiciuokle-di/
//https://invega.lt/wp-content/plugins/inv-calc-covid-di/public/js/inv-calc-covid-di-public.js?ver=1.0






// MVI skaiciuokle
EwSiteApp.controller('MVICalcCtrl', ['$scope', function ($scope) {
		$scope.showInfo = false;
		$scope.statusPareiskejoInfo = false;
		$scope.statusBendraInfo = false;

		$scope.susijusiosI = [];
		$scope.pareiskejoI = {
			'nuosavas': '',
			'istatinis': ''
		};

		// Ar imone patiria sunkumus
		var hasDifficulties = function (kapitalas, istatinisKapitalas) {
			// jei kapitalas mažesnis už pusę įstatinio, įmonė laikoma patiriančia sunkumus
			if (kapitalas < istatinisKapitalas / 2) {
				return false;
			}
			return true;
		};

		var calculateAllBlocksTotal = function () {
			var susijusiuNuosavasTotal = 0;
			var susijusiuIstatinisTotal = 0;

			for (var i = 0, l = $scope.susijusiosI.length; i < l; i++) {
				susijusiuNuosavasTotal += $scope.susijusiosI[i].nuosavas;
				susijusiuIstatinisTotal += $scope.susijusiosI[i].istatinis;
			}

			var nuosavasTotal = susijusiuNuosavasTotal + $scope.pareiskejoI.nuosavas;
			var istatinisTotal = susijusiuIstatinisTotal + $scope.pareiskejoI.istatinis;

			return hasDifficulties(nuosavasTotal, istatinisTotal);
		};

		$scope.submitOnEnter = function (e) {
			if (e.which === 13 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
				e.preventDefault();

				if ($scope.checkAllFields()) {
					return false;
				}

				$scope.calculate();
			}
		};

		$scope.calculate = function () {
			$scope.showInfo = true;
			$scope.showDICalcForms = false;

			$scope.statusPareiskejoInfo = hasDifficulties($scope.pareiskejoI.nuosavas, $scope.pareiskejoI.istatinis);
			if ($scope.susijusiosI.length > 0) {
				$scope.statusBendraInfo = calculateAllBlocksTotal();
			}
		};

		$scope.add = function () {
			$scope.susijusiosI.push({
				'nuosavas': '',
				'istatinis': ''
			});

			$scope.resetForm();
		};

		$scope.remove = function (index) {
			$scope.susijusiosI.splice(index, 1);

			$scope.resetForm();
		};

		$scope.checkAllFields = function () {
			if (!angular.isNumber($scope.pareiskejoI.nuosavas) || !angular.isNumber($scope.pareiskejoI.istatinis)) {
				return true;
			}

			if ($scope.susijusiosI.length > 0) {
				for (var i = 0, l = $scope.susijusiosI.length; i < l; i++) {
					if (!angular.isNumber($scope.susijusiosI[i].nuosavas) || !angular.isNumber($scope.susijusiosI[i].istatinis)) {
						return true;
					}
				}
			}

			return false;
		};

		$scope.resetForm = function () {
			$scope.showInfo = false;
			$scope.statusPareiskejoInfo = false;
			$scope.statusBendraInfo = false;
		};
	}]);

//https://invega.lt/lt/covid-19/kas-yra-sunkumu-patirianti-imone/sunkumu-vertinimo-skaiciuokle-mvi/
//https://invega.lt/wp-content/plugins/inv-calc-covid-di/public/js/inv-calc-covid-mvi-public.js?ver=1.0






// Garantiju skaiciuokle
EwSiteApp.controller('GarantijosSkaiciuoklesCtrl', ['$scope', '$log', function ($scope, $log) {
		// SVV
		// fiksuota baze
		// visos imones iki 3 metu
		var F1 = 1;
		// apyvartines nuo 3 metu
		var F2 = 1;
		// investicines nuo 3 metu
		var F3 = 1.5;

		// metine priemoka
		// apyvartinems
		var F11 = 0.4;
		// investicinems
		var F12 = 0.2;

		// DI
		// fiksuota baze
		// visos imones iki 3 metu
		var F21 = 2;
		// apyvartines nuo 3 metu
		var F22 = 1;
		// investicines nuo 3 metu
		var F23 = 1.5;

		// metine priemoka
		// apyvartinems
		var F31 = 0.4;
		// investicinems
		var F32 = 0.2;

		$scope.paskolosSuma = '';
		$scope.paskolosTipas = '';
		$scope.paskolosGavejoAmzius = '';
		$scope.paskolosGavejoDydis = '';
		$scope.atsakomybesLimitas = '';
		$scope.trukme = '';
		$scope.loading = false;

		$scope.showResults = false;

		var setDefaultValues = function () {
			$scope.paskolosSuma = '';
			$scope.paskolosTipas = 'investicine';
			$scope.paskolosGavejoAmzius = 'iki3';
			$scope.paskolosGavejoDydis = 'svv';
			$scope.atsakomybesLimitas = '';
			$scope.trukme = '1';
		};

		var toDecimal = function (number) {
			return (Math.round(number * 100) / 100).toFixed(2);
		};

		var calculateSVV = function (paskolosGavejoAmzius, paskolosTipas, trukme) {
			var baze = F2;
			var metinePriemoka = F11;

			if (paskolosTipas === 'investicine') {
				baze = F3;
				metinePriemoka = F12;
			}
			if (paskolosGavejoAmzius === 'iki3') {
				baze = F1;
			}

			return (baze + (trukme - 1) * metinePriemoka) / 100;
		};

		var calculateDI = function (paskolosGavejoAmzius, paskolosTipas, trukme) {

			var baze = F22;
			var metinePriemoka = F31;

			if (paskolosTipas === 'investicine') {
				baze = F23;
				metinePriemoka = F32;
			}
			if (paskolosGavejoAmzius === 'iki3') {
				baze = F21;
			}

			return (baze + (trukme - 1) * metinePriemoka) / 100;
		};

		$scope.calculate = function () {
			$scope.loading = true;
			var paskolosSuma = $scope.paskolosSuma;
			var atsakomybesLimitas = ($scope.atsakomybesLimitas !== '' && $scope.atsakomybesLimitas > 0) ? $scope.atsakomybesLimitas / 100 : 0;
			var garantijosSuma = paskolosSuma * atsakomybesLimitas;
			var paskolosTipas = $scope.paskolosTipas;
			var paskolosGavejoAmzius = $scope.paskolosGavejoAmzius;
			var paskolosGavejoDydis = $scope.paskolosGavejoDydis;
			var trukme = $scope.trukme;

			var maksimalusGarantijosAtlyginimasEurIki3 = 5000000;
			var maksimalusGarantijosAtlyginimasEurVirs3 = 5000000;

			var maksimaliGarantijosSumaEurIki3 = 5000000;
			var maksimaliGarantijosSumaEurVirs3 = 5000000;
			
			if (paskolosGavejoAmzius === 'iki3' && garantijosSuma >= maksimalusGarantijosAtlyginimasEurIki3) {
				garantijosSuma = maksimaliGarantijosSumaEurIki3;
			} else if (paskolosGavejoAmzius === 'virs3' && garantijosSuma >= maksimalusGarantijosAtlyginimasEurVirs3) {
				garantijosSuma = maksimaliGarantijosSumaEurVirs3;
			} else {
				var garantijosSuma = paskolosSuma * atsakomybesLimitas;
			}

			var garantijosAtlyginimasProc = 0;

			if (paskolosGavejoDydis === 'svv') {
				garantijosAtlyginimasProc = calculateSVV(paskolosGavejoAmzius, paskolosTipas, trukme);
			} else {
				garantijosAtlyginimasProc = calculateDI(paskolosGavejoAmzius, paskolosTipas, trukme);
			}
			var garantijosAtlyginimasEur = garantijosAtlyginimasProc * garantijosSuma;

			$scope.garantijosSumaPlain = toDecimal(garantijosSuma);
			$scope.garantijosSuma = toDecimal(garantijosSuma) + '€';
			$scope.garantijosAtlyginimasProc = toDecimal(garantijosAtlyginimasProc * 100) + '%';
			$scope.garantijosAtlyginimasEur = toDecimal(garantijosAtlyginimasEur) + '€';

			$scope.showResults = true;

			setTimeout(function () {
				$scope.$apply(function () {
					$scope.loading = false;
				});
			}, 500);

//		console.log('suma ', $scope.garantijosSuma, ' proc ', $scope.garantijosAtlyginimasProc, ' eur ', $scope.garantijosAtlyginimasEur);
//			console.log(garantijosSuma)
		};

		$scope.checkAllFields = function () {
			if (!angular.isNumber($scope.paskolosSuma) || !angular.isNumber($scope.atsakomybesLimitas)) {
				return true;
			}
			if ($scope.atsakomybesLimitas > 80) {
				return true;
			}
			if ($scope.garantijosSuma < 5000) {
				return true;
			}
//			console.log($scope.garantijosSumaPlain)
			return false;
		};

		setDefaultValues();
	}]);